module.exports = __webpack_public_path__ + "static/media/efecty.9b9a05c0.png";